// @ts-check
/**
 * @file api/subscription.js
 * @location src/integrations/supabase/api/subscription.js
 * @role rpc_subscription_state RPC 래퍼 — hydrate 시·갱신 시 호출.
 *
 *  rpc 가 `returns table(...)` 라 supabase-js 는 array 반환 — 첫 row 만 도메인 모델로 변환.
 *  row 없으면 null(가입 직후 race 등).
 *
 *  반환: { status, trialEndsAt, currentPeriodEnd, hasCustomer, memberCap, teamId } | null
 */
import { callRpc } from './_call.js';

export async function getSubscriptionState() {
  return callRpc('rpc_subscription_state', {}, (data) => {
    const row = Array.isArray(data) ? data[0] : data;
    if (!row) return null;
    return {
      status: row.status,
      trialEndsAt: row.trial_ends_at,
      currentPeriodEnd: row.current_period_end,
      hasCustomer: row.has_customer,
      memberCap: row.member_cap ?? null,
      teamId: row.team_id ?? null,
    };
  });
}
